import React, { useEffect } from "react";

const TrackingScripts = () => {

  // Google Ads gtag — Remarketing (AW-961178487, AW-848956189, AW-736858127, AW-11185178531) + DV 360 (DC-8971752)
  // + Conversions (Sal-Corp-EL, SA-ApplyNow, DV360 Floodlight)
  // useEffect(() => {
  //   if (document.getElementById("gtag-salcorp")) return;

  //   window.dataLayer = window.dataLayer || [];
  //   function gtag() { window.dataLayer.push(arguments); }
  //   window.gtag = gtag;

  //   const script = document.createElement("script");
  //   script.id = "gtag-salcorp";
  //   script.async = true;
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=AW-961178487";
  //   document.head.appendChild(script);

  //   gtag("js", new Date());

  //   // Remarketing configs
  //   gtag("config", "AW-961178487");
  //   gtag("config", "AW-848956189");
  //   gtag("config", "AW-736858127");
  //   gtag("config", "AW-11185178531");

  //   // DV 360 (DC Floodlight) config
  //   gtag("config", "DC-8971752");

  //   // Conversion events
  //   gtag("event", "conversion", { send_to: "AW-11185178531/BOlHCMSH9KEYEKOPwdUp" });
  //   gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });

  //   // DV 360 Floodlight conversion
  //   gtag("event", "conversion", {
  //     allow_custom_scripts: true,
  //     send_to: "DC-8971752/invmedia/salcor03+standard",
  //   });
  // }, []);


  useEffect(() => {
    if (document.getElementById("gtag-salcorp")) return;

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;

    const userData = localStorage.getItem("userData");
    const retrievedData = userData ? JSON.parse(userData) : null;

    // Queue all commands into dataLayer BEFORE the script loads —
    // this matches Google's standard pattern. The async script picks up
    // the queue on load and processes every item in order.
    gtag("js", new Date());

    // Remarketing configs
    gtag("config", "AW-961178487");
    gtag("config", "AW-848956189");
    gtag("config", "AW-736858127");


    // ECL on AW-11185178531
    if (retrievedData?.mobile && retrievedData.mobile) {
      gtag("config", "AW-11185178531", { allow_enhanced_conversions: true });
      gtag("set", "user_data", { "email": retrievedData.email, "phone_number": retrievedData.mobile });
    } else {
      gtag("config", "AW-11185178531");
    }

    // DV 360 (DC Floodlight) config
    gtag("config", "DC-8971752");

    // Conversion events
    gtag("event", "conversion", { send_to: "AW-11185178531/BOlHCMSH9KEYEKOPwdUp" });
    gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });

    gtag("event", "form_submit", { send_to: "AW-11185178531" });
    // DV 360 Floodlight conversion
    gtag("event", "conversion", {
      allow_custom_scripts: true,
      send_to: "DC-8971752/invmedia/salcor03+standard",
    });

    const script = document.createElement("script");
    script.id = "gtag-salcorp";
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-961178487";
    document.head.appendChild(script);
  }, []);


  // Facebook Pixel — Remarketing (PageView) + Conversion (Sal-Corp-EL, SA-ApplyNow)
  useEffect(() => {
    if (window.fbEventFired) return;
    window.fbEventFired = true;

    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    }

    window.fbq("init", "1109423764622443");
    window.fbq("track", "PageView");                  // Remarketing
    window.fbq("trackCustom", "Sal-Corp-EL");          // Conversion
    window.fbq("trackCustom", "SA-ApplyNow");          // Conversion
  }, []);

  // LinkedIn Insight Tag — partner ID 5534113
  useEffect(() => {
    if (document.getElementById("linkedin-insight")) return;

    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push("5534113");

    (function (l) {
      if (!l) {
        window.lintrk = function (a, b) { window.lintrk.q.push([a, b]); };
        window.lintrk.q = [];
      }
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.id = "linkedin-insight";
      b.type = "text/javascript";
      b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);
    })(window.lintrk);
  }, []);

  // Bing UET Tags — 97231496 and 97231495
  useEffect(() => {
    if (document.getElementById("bing-uet")) return;

    window.uetq = window.uetq || [];
    window.uetq2 = window.uetq2 || [];

    const script = document.createElement("script");
    script.id = "bing-uet";
    script.src = "https://bat.bing.com/bat.js";
    script.async = true;
    script.onload = () => {
      window.uetq = new window.UET({ ti: "97231496", enableAutoSpaTracking: true, q: window.uetq });
      window.uetq.push("pageLoad");

      window.uetq2 = new window.UET({ ti: "97231495", enableAutoSpaTracking: true, q: window.uetq2 });
      window.uetq2.push("pageLoad");
    };
    document.body.appendChild(script);
  }, []);

  // MS Clarity — vn9yec4mqm
  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "vn9yec4mqm");
  }, []);

  // MS Clarity — vn9y1utxz2
  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "vn9y1utxz2");
  }, []);

  return null;
};

export default TrackingScripts;
